import { render } from "./testingtag.vue?vue&type=template&id=444253a6"
import script from "./testingtag.vue?vue&type=script&lang=js"
export * from "./testingtag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__